// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentMoveMemberNumberBySurveyQuestionResultModel {
    static getAttributeTypeMap() {
        return EnrollmentMoveMemberNumberBySurveyQuestionResultModel.attributeTypeMap;
    }
}
EnrollmentMoveMemberNumberBySurveyQuestionResultModel.discriminator = undefined;
EnrollmentMoveMemberNumberBySurveyQuestionResultModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "sourceGroup",
        "baseName": "sourceGroup",
        "type": "string"
    },
    {
        "name": "sourceOfferType",
        "baseName": "sourceOfferType",
        "type": "number"
    },
    {
        "name": "sourceBatchId",
        "baseName": "sourceBatchId",
        "type": "number"
    },
    {
        "name": "sourceTcProgramId",
        "baseName": "sourceTcProgramId",
        "type": "number"
    },
    {
        "name": "destinationGroup",
        "baseName": "destinationGroup",
        "type": "string"
    },
    {
        "name": "destinationOfferType",
        "baseName": "destinationOfferType",
        "type": "number"
    },
    {
        "name": "destinationBatchId",
        "baseName": "destinationBatchId",
        "type": "number"
    },
    {
        "name": "destinationTcProgramId",
        "baseName": "destinationTcProgramId",
        "type": "number"
    }
];
//# sourceMappingURL=enrollmentMoveMemberNumberBySurveyQuestionResultModel.js.map